import { AppointmentState } from "../../types";
import { BookingStage } from "../../constants/bookingStages";
import type { Action } from "../store";

interface AddAppointmentPayload {
  stage: number;
  domain?: string;
  shopData?: any;
  rwg_token?: string;
  entryStage?: number;
  specId?: number;
  [key: string]: any;
}

interface UpdateAppointmentPayload {
  updates: Partial<AppointmentState>;
}

interface ResetAppointmentPayload {
  dispatchData: Partial<AppointmentState>;
}

const initialState: AppointmentState = {
  stage: BookingStage.Location,
};

export const addAppointment = (payload: AddAppointmentPayload) => ({
  type: "appointments/addAppointment" as const,
  payload,
});
export const updateAppointment = (payload: UpdateAppointmentPayload) => ({
  type: "appointments/updateAppointment" as const,
  payload,
});
export const resetAppointment = (payload: ResetAppointmentPayload) => ({
  type: "appointments/resetAppointment" as const,
  payload,
});

export default function appointmentReducer(
  state: AppointmentState = initialState,
  action: Action
): AppointmentState {
  switch (action.type) {
    case "appointments/addAppointment": {
      const payload = action.payload as AddAppointmentPayload;
      return {
        ...state,
        stage: payload.stage,
        domain: payload.domain,
        shopData: payload.shopData,
        rwg_token: payload.rwg_token,
        entryStage: payload.entryStage,
        specId: payload.specId,
        ...(payload.sourceQueryString !== undefined && {
          sourceQueryString: payload.sourceQueryString,
        }),
      };
    }
    case "appointments/updateAppointment": {
      const { updates } = action.payload as UpdateAppointmentPayload;
      return {
        ...state,
        vehicle: updates.vehicle ? { ...state.vehicle, ...updates.vehicle } : state.vehicle,
        ...updates,
      };
    }
    case "appointments/resetAppointment":
      return { ...(action.payload as ResetAppointmentPayload).dispatchData } as AppointmentState;
    default:
      return state;
  }
}
